<template>
  <!-- 当前状态 -->
  <div class="container">
    <div class="fdr">
      <p class="green fs46 el-icon-success" v-if="applymentDetail.applymentStatus == 'FINISH'"></p>
      <p class="red fs46 el-icon-error" v-else-if="applymentDetail.applymentStatus == 'ILLEGAL' || applymentDetail.applymentStatus == 'AUDIT_FAIL'"></p>
      <p
        class="orange fs46 el-icon-warning"
        v-else-if="
          applymentDetail.applymentStatus == 'REJECTED' ||
          applymentDetail.applymentStatus == 'REFUND_APPLY_DENY' ||
          applymentDetail.applymentStatus == 'REFUND_APPLY_REJECT' ||
          applymentDetail.applymentStatus == 'ACRA_REJECTED'
        "
      ></p>
      <p class="blue fs46 el-icon-info" v-else></p>
      <div class="ml6 sjz">
        <p class="fs18 lh1em fw600">
          {{ getGlobalLabel("applymentStatusList", applymentDetail.applymentStatus) }}
        </p>
      </div>
    </div>

    <div class="pt20">
      <!-- 交易代码 -->
      <p class="singleTitle">{{ $t("payment.transactionNo") }}</p>
      <div class="singleContent">
        <p class="fs14">{{ applymentDetail.applymentNo }}</p>
      </div>
    </div>

    <template v-if="!(isCoordinator && applymentDetail.isLaterService)">
      <div class="pt20 singleWrap" v-if="applymentDetail.companyFinishInfo || applymentDetail.acraCompanyInfoList?.length > 0">
        <p class="singleTitle">{{ $t("enroll.details.establish") }}</p>
        <div class="mt10 material">
          <template v-if="applymentDetail.acraCompanyInfoList?.length > 0">
            <div v-for="(item, index) in applymentDetail.acraCompanyInfoList" :key="`acraCompanyInfo-${item.uen}-${index}`">
              <p class="mr0 mb6 singleText">
                <span class="mr6">{{ $t("enroll.details.company") }}</span>
                <span>{{ item.companyName }}</span>
              </p>
              <p class="mr0 mb6 singleText">
                <span class="mr6">{{ $t("enroll.details.license") }}</span>
                <span>{{ item.uen }}</span>
              </p>
            </div>
          </template>

          <template v-if="applymentDetail.companyFinishInfo">
            <p class="mr0 mb6 singleText">
              <span class="mr6">{{ $t("enroll.details.constitution") }}</span>
              <a v-for="item in applymentDetail.companyFinishInfo.articlesOfIncorporationUrls" :key="item.url" :href="item.url" target="_blank" class="fs12 blue mr10">
                {{ item.name }}
              </a>
            </p>
            <p class="mr0 mb6 singleText">
              <span class="mr6">{{ $t("enroll.details.commercial") }}</span>
              <a v-for="item in applymentDetail.companyFinishInfo.businessDocumentsUrls" :key="item.url" :href="item.url" target="_blank" class="fs12 blue mr10">
                {{ item.name }}
              </a>
            </p>
            <p class="mr0 mb6 singleText">
              <span class="mr6">{{ $t("enroll.details.accessory") }}</span>
              <a v-for="item in applymentDetail.companyFinishInfo.otherDocumentsUrls" :key="item.url" :href="item.url" target="_blank" class="fs12 blue mr10">
                {{ item.name }}
              </a>
            </p>
          </template>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";
export default {
  data() {
    return {};
  },
  computed: {
    ...mapState("user", ["isCoordinator"]),
    ...mapState("applyment", ["applymentDetail"]),
    ...mapGetters("constant", ["getGlobalLabel"]),
  },
  methods: {},
};
</script>

<style lang="scss" scoped>
.singleTitle {
  font-size: 16px;
  font-weight: 600;
  line-height: 20px;
  padding-bottom: 10px;
}

.singleText {
  font-size: 12px;
  line-height: 22px;
  margin-right: 30px;
  word-wrap: break-word;
  word-break: break-all;
}

.material {
  width: 100%;
  padding: 12px;
  border: 1px solid #ebeef5;
}
</style>
